define( function() {
	"use strict";

	return [];
} );



// WEBPACK FOOTER //
// ./node_modules/jquery/src/var/arr.js